import { render, staticRenderFns } from "./MintalMesPrdShiftPlanList.vue?vue&type=template&id=b81da606&"
import script from "./MintalMesPrdShiftPlanList.vue?vue&type=script&lang=js&"
export * from "./MintalMesPrdShiftPlanList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports